import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const items = [['S.M.', 'Dance Fitness Instructor — London, UK', 'I used to spend my Sunday evenings building routines from scratch. Now I open the system, pick the class, and walk in completely ready.'], ['C.V.', 'Dance Fitness Instructor — Toronto, Canada', 'The 50 ready-to-teach lesson plans alone saved me more hours than I can count in my first month.'], ['J.R.', 'Dance Fitness Instructor — Sydney, Australia', 'The choreography combinations completely changed the way I build my classes. My sessions feel more professional and students keep coming back.']];
export function TestimonialsStrip() {
  return <section className="border-y border-charcoal-line bg-charcoal-card py-10" data-id="element-229">
      <div className="mx-auto grid max-w-7xl gap-5 px-4 md:grid-cols-3" data-id="element-230">
        {items.map(([name, role, quote], index) => <motion.figure key={name} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="rounded-2xl border border-gold/25 bg-charcoal p-6" data-id="element-231">
            <div className="mb-4 flex gap-1 text-gold-light" data-id="element-232">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} size={15} fill="currentColor" data-id="element-233" />)}
            </div>
            <blockquote className="text-sm italic leading-relaxed text-zinc-300" data-id="element-234">
              “{quote}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3" data-id="element-235">
              <span className="flex size-9 items-center justify-center rounded-full border border-gold/60 bg-gold/10 text-xs font-bold text-gold-light" data-id="element-236">
                {name}
              </span>
              <span className="text-xs text-gold-light" data-id="element-237">{role}</span>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}